import React, { useState } from 'react';
import axios from 'axios';
import { useNotifications } from '../../hooks/useNotifications';

const AxiosDebug: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const notifications = useNotifications();

  const testAxiosConfig = () => {
    setResult({
      baseURL: axios.defaults.baseURL,
      timeout: axios.defaults.timeout,
      headers: axios.defaults.headers,
      method: 'GET',
      url: '/posts'
    });
  };

  const testDirectAPI = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/posts');
      setResult({
        status: response.status,
        data: response.data,
        config: {
          baseURL: response.config.baseURL,
          url: response.config.url,
          method: response.config.method
        }
      });
      notifications.success.postCreated();
    } catch (error: any) {
      setResult({
        error: error.message,
        status: error.response?.status,
        data: error.response?.data,
        config: {
          baseURL: error.config?.baseURL,
          url: error.config?.url,
          method: error.config?.method
        }
      });
      notifications.error.postCreate(error.message);
    } finally {
      setLoading(false);
    }
  };

  const testCreatePost = async () => {
    setLoading(true);
    try {
      // Primeiro fazer login com role admin
      const loginResponse = await axios.post('/auth/register', {
        name: 'Debug User Admin',
        email: 'debugadmin@test.com',
        password: 'debug123',
        role: 'admin'
      });

      const token = loginResponse.data.token;
      const user = loginResponse.data.user;

      // Criar post
      const postResponse = await axios.post('/posts', {
        title: 'Post de Debug React - ' + new Date().toISOString(),
        content: 'Este é um post criado via debug React para testar a funcionalidade de criação de posts. Conteúdo com mais de 50 caracteres para passar na validação.',
        category: 'geral',
        isPublished: true
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      setResult({
        success: true,
        post: postResponse.data,
        user: user,
        token: token
      });
      notifications.success.postCreated();
    } catch (error: any) {
      setResult({
        error: error.message,
        status: error.response?.status,
        data: error.response?.data,
        config: {
          baseURL: error.config?.baseURL,
          url: error.config?.url,
          method: error.config?.method
        }
      });
      notifications.error.postCreate(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <h3 className="text-xl font-semibold text-gray-900 mb-4">
        🔧 Debug Axios - React
      </h3>
      
      <div className="space-y-4">
        <div className="flex space-x-2">
          <button
            onClick={testAxiosConfig}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Ver Config Axios
          </button>
          
          <button
            onClick={testDirectAPI}
            disabled={loading}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 disabled:opacity-50"
          >
            {loading ? 'Testando...' : 'Testar API Direta'}
          </button>
          
          <button
            onClick={testCreatePost}
            disabled={loading}
            className="px-4 py-2 bg-purple-500 text-white rounded hover:bg-purple-600 disabled:opacity-50"
          >
            {loading ? 'Criando...' : 'Testar Criar Post'}
          </button>
        </div>

        {result && (
          <div className="mt-4">
            <h4 className="font-medium text-gray-900 mb-2">Resultado:</h4>
            <pre className="bg-gray-100 p-4 rounded text-sm overflow-x-auto">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}

        <div className="mt-4 p-4 bg-gray-50 rounded">
          <h4 className="font-medium text-gray-900 mb-2">Informações do Axios:</h4>
          <ul className="text-sm text-gray-600 space-y-1">
            <li><strong>Base URL:</strong> {axios.defaults.baseURL || 'Não configurado'}</li>
            <li><strong>Timeout:</strong> {axios.defaults.timeout || 'Padrão'}</li>
            <li><strong>Headers:</strong> {JSON.stringify(axios.defaults.headers.common)}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AxiosDebug;
